import request from '@/utils/request';

export default{
  //现场实时数据
  realData(opt) {
    const params = {
      ...opt
    }
    return request.get('/projectsite/getSerialNumberDate/', {
      params: params
    });
  },
  //新增网关
  addProjectSite(postData){
    return request.post('/projectsite/addProjectSite', postData);
  },
  //项目现场数据
  projectsiteData(opt) {
    const params = {
      ...opt
    }
    return request.get('/projectsite/list/' + opt.page + '/' + opt.size + '/' + opt.device_status, {
      params: params
    });
  },
  //根据网关名称或序列号获取现场数据
  getProjectsiteData(opt) {
    const params = {
      ...opt
    }
    return request.get('/projectsite/getewayNameOrSerialNumber/' + opt.page + '/' + opt.size, {
      params: params
    });
  },
  //获取用户个人资料
  getUserInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/user/basicInformationOfUsers', {
      params: params
    });
  },
  //修改用户个人资料
  editUserInfo(postData){
    return request.post('/user/modifyBasicInformationOfUsers', postData);
  },
  //修改密码
  updatePassword(postData){
    return request.post('/user/updatePassword', postData);
  },
  //获取趋势图数据
  getTrendChart(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/trendChart', {
      params: params
    });
  },
  //根据序列号获取告警数据
  getAlarmData(opt){
    const params = {
      user_id:opt.user_id,
      user_token:opt.user_token,
      serialNumber:opt.serialNumber,
      status:opt.status,
    }
    return request.get('/projectsite/serialNumberQueryAlarm/' + opt.page + '/' + opt.size + '/' + opt.status, {
      params: params
    });
  },
  //获取全部告警数据
  getAlarmDataAll(opt){
    const params = {
      user_id:opt.user_id,
      user_token:opt.user_token,
      status:opt.status,
    }
    return request.get('/projectsite/serialNumberQueryAlarm/' + opt.page + '/' + opt.size + '/' + opt.status, {
      params: params
    });
  },
  //根据序列号获取历史告警数据
  getHistoryAlarmData(opt){
    const params = {
      user_id:opt.user_id,
      user_token:opt.user_token,
      serialNumber:opt.serialNumber,
      status:opt.status,
      onlineOnOffline:opt.onlineOnOffline,
      startTime:opt.startTime,
      endTime:opt.endTime,
      alarm_type:opt.alarm_type
    }
    return request.get('/projectsite/serialNumberQueryHistoryAlarm/' + opt.page + '/' + opt.size + '/' + opt.status, {
      params: params
    });
  },
  //获取日志信息
  getLogData(opt){
    const params = {
      ...opt
    }
    return request.get('/user/queryUserLog/'+ opt.page + '/' + opt.size,{
      params: params
    });
  },
  //修改项目现场名称
  updateSerialNumber(postData){
    return request.post('/projectsite/updateSerialNumber', postData);
  },
  //删除项目现场
  deleteProjectSite(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/deleteProjectSite',{
      params: params
    });
  },
  //修改实时数据数值
  updateVariableValues(postData){
    return request.post('/projectsite/updateVariableValues', postData);
  },
  //获取部门信息
  getDeptInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/dept/queryDeptInformation',{
      params: params
    });
  },
  //新增部门
  addDept(postData){
    return request.post('/dept/insertDept', postData);
  },
  //修改部门
  updataDept(postData){
    return request.post('/dept/updataDept', postData);
  },
  //删除部门
  deleteDept(opt){
    const params = {
      ...opt
    }
    return request.get('/dept/deleteDepartmentByID',{
      params: params
    });
  },
  //获取岗位信息
  getPostInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/post/userQueryPosition',{
      params: params
    });
  },
  //新增岗位
  addPost(postData){
    return request.post('/post/insertPost', postData);
  },
  //修改岗位
  updataPost(postData){
    return request.post('/post/updataPost', postData);
  },
  //删除岗位
  deletePost(opt){
    const params = {
      ...opt
    }
    return request.get('/post/deletePositionByID',{
      params: params
    });
  },
  //获取用户权限信息
  getUserJurisdictionInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/user/findUserInfo',{
      params: params
    });
  },
  //用户权限新增用户
  addUser(postData){
    return request.post('/user/newSubUser', postData);
  },
  //修改用户权限
  updataUser(postData){
    return request.post('/user/updateUserInfo', postData);
  },
  //删除用户权限
  deleteUser(opt){
    const params = {
      ...opt
    }
    return request.get('/user/delectUserInfo',{
      params: params
    });
  },
  //获取地图信息
  getMapInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/returnToMapBasicInformation',{
      params: params
    });
  },
  //查询网关基本信息
  getGatewayInformation(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryGatewayInformation',{
      params: params
    });
  },
  //查询网关流量
  getGatewayFlow(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryGatewayFlow',{
      params: params
    });
  },
  //修改模板变量
  updateTemplateVariable(postData){
    return request.post('/projectsite/updateTemplateVariable', postData);
  },
  //获取模板变量
  getTemplateVariable(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryTemplateVariable',{
      params: params
    });
  },
   //导出经纬度
   exportPosition(opt){
    const params = {
      ...opt
    }
    return request.get('/map/exportLatitudeAndLongitude', {
      params: params
    });
  },
  //首页在线率
  onLine(opt){
    const params = {
      ...opt
    }
    return request.get('/wx/disk', {
      params: params
    });
  },
  //建议反馈
  Feedback(opt){
    const params = {
      ...opt
    }
    return request.get('/user/querySuggestionFeedback/'+ opt.page + '/' + opt.size,{
      params: params
    });
  },
  //查询inhand账号
  getDmUserInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/user/queryDmUserInfo',{
      params: params
    });
  },
  //修改inhand账号
  updateDmUserInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/user/addDmUserInfo',{
      params: params
    });
  },
  //获取历史数据趋势图页面
  getTableHistoryData(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryTableHistoryData/'+ opt.page + '/' + opt.size,{
      params: params
    });
  },
  //修改部门权限
  editDeptJurisdiction(postData){
    return request.post('/dept/updataDeptJurisdiction', postData);
  },
  //查询部门权限
  getDeptJurisdiction(opt){
    const params = {
      ...opt
    }
    return request.get('/dept/queryDeptJurisdiction',{
      params: params
    });
  },
  //恺雷日报
  getDaily(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/daily',{
      params: params
    });
  },
  //恺雷月报
  getMonthlyReport(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/monthlyReport',{
      params: params
    });
  },
  querySpecificDataBySerialNumbers(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/querySpecificDataBySerialNumbers',{
      params: params
    });
  },
  //项目编号模糊查询
  queryItemNo(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryItemNoById',{
      params: params
    });
  },
  //查询趋势图所需变量
  queryTrendChartRequiredVariables(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryTrendChartRequiredVariables',{
      params: params
    });
  },
  //根据用户ID查询变量状态
  queryVariableStatusByUserId(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryVariableStatusByUserId/'+ opt.page + '/' + opt.size,{
      params: params
    });
  },
  //查询设备信息记录
  queryEquipmentInformationEecord(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryEquipmentInformationEecord/'+ opt.page + '/' + opt.size,{
      params: params
    });
  },
  //查询机组运行数据
  queryUnitOperationData(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryUnitOperationData',{
      params: params
    });
  },
  //查询报警实时数据
  queryAlarmsRealtimeData(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryAlarmsRealtimeData',{
      params: params
    });
  },
  //3d趋势图
  trendChartOf3D(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/trendChartOf3D',{
      params: params
    });
  },
  //3d部件数据
  componentDataOf3D(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/componentDataOf3D',{
      params: params
    });
  },
  //查询定时器
  queryTimer(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryTimer',{
      params: params
    });
  },
  //修改定时器
  updateTimer(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/updateTimer',{
      params: params
    });
  },
}